<template>
    <div class="CCcontent">
        <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;width:100%;height:100%;padding-top:20%"
            v-if="deviceList.length == 0">
            <img :src="require('../../assets/img/not_found_data.png')" alt="">
        </div>
        <div v-else class="itemContainer">
            <CapacitanceItems v-for="(item,index) in deviceList" :key="index" :device="item" :AreaName="AreaName"/>
        </div>
    </div>
</template>

<script>
    import CapacitanceItems from './components/CapacitanceItems'
    import {
        LowFeedDevice,
        GET_AREAS,
    } from "../../api/power"
    import {
        connect,
        destroyConnection,
        subscribebyLoopUrl,
        unsubscribebyLoopUrl
    } from '../../mqtt/loopdata'
    export default {
        name: "CapacitanceCompensation",
        components: {
            CapacitanceItems,
        },
        data() {
            return {
                deviceList: [{}],
                AreaName:""
            }
        },
        mounted(){
            connect()
            this.getLowFeedDevices();
            GET_AREAS().then(res => {
                // console.log(res.data.data.areas)
                this.AreaName = res.data.data.areas[0].areaName
            })
        },
        computed:{
            // AreaName(){
            //     return this.$store.getters.selAreaInfo.areaName
            // },
        },
        methods: {
            async getLowFeedDevices() {
                // let res = await LowFeedDevice(this.$store.getters.areaId)


                let promises = [];

                this.$store.state.project.projectInfo.areaList.forEach(item=>{
                    promises.push(LowFeedDevice(item.areaId))
                })
                Promise.all(promises).then((res) => {
                    let pointsArray = []
                    let map = res.map((r) => (r.data ? r.data.data.res : []));
                    
                    map.forEach((item,index)=>{
                        item = item.map(e=>{
                            e.AreaName=this.$store.state.project.projectInfo.areaList[index].areaName;
                            subscribebyLoopUrl(e.subLoopUrl); 
                            return e
                        })
                        pointsArray = pointsArray.concat(item)
                    })
                    console.log(pointsArray,"pointsArray")
                    this.deviceList = pointsArray
                })

                // if (res.data.data.res) {
                //     this.deviceList = res.data.data.res || []
                //     this.deviceList.forEach(item => {
                //         if (item.subLoopUrl)
                //             subscribebyLoopUrl(item.subLoopUrl)
                //     })
                // }
            }
        },
        beforeDestroy() {
            this.deviceList.forEach(item => {
                if (item.subLoopUrl)
                    unsubscribebyLoopUrl(item.subLoopUrl)
            })
            destroyConnection()
        }
    };
</script>

<style lang="less" scoped>
    .CCcontent {
        width: 100%;
        
    }

    .itemContainer {
        width: 100%;
        height: 100%;
        // overflow-y: scroll;
        // scrollbar-width: none;
    }

    // ::-webkit-scrollbar {
    //     display: none;
    // }
</style>